var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBottombarLessonsActive = function SvgBottombarLessonsActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#bottombar-lessons-active_svg__a)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M7 13.86v-3.344C7 7.21 7 5.557 8.06 4.993s2.432.359 5.174 2.206l2.602 1.752c2.325 1.566 3.488 2.349 3.464 3.44-.024 1.093-1.22 1.825-3.61 3.289l-2.601 1.592c-2.696 1.65-4.044 2.476-5.067 1.903C7 18.602 7 17.022 7 13.861"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bottombar-lessons-active_svg__a",
    x1: 13.15,
    x2: 13.15,
    y1: 4.828,
    y2: 19.357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1967DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#001A9F"
  })))));
};
export default SvgBottombarLessonsActive;